import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ElectricVehicleList from './ElectricVehicleList';
import ElectricVehicleCreate from './ElectricVehicleCreate';
import ElectricVehicleEdit from './ElectricVehicleEdit';

const ElectricVehicle = () => {
  return (
    <Routes>
      <Route path="/" element={<ElectricVehicleList />} />
      <Route path="/create" element={<ElectricVehicleCreate />} />
      <Route path="/edit/:id" element={<ElectricVehicleEdit />} />
    </Routes>
  );
};

export default ElectricVehicle;
